<ng-container *ngIf="(errors$ | async) && control?.invalid === true && control?.touched">
  <div class="error" *ngFor="let error of errors$.value">{{error}}</div>
</ng-container>
